<template></template>

<script>
export default {
    name: 'complainList',
    created() {
        location.href = '/Index/complain.html'
    }
}
</script>